<template>
  <ProductionOrderStepEmbeddable v-model="form"/>
</template>
<script>
import productionOrderStepEmbeddableMixin from "@/mixins/embeddable/production/productionOrderStepEmbeddableMixin"


export default {
  name: 'ProductionOrderStep',
  mixins: [productionOrderStepEmbeddableMixin],
  data() {
    return {
      form: {},
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
}
</script>
